<template>
    <section class="doc-section">
        <!-- Selector de Plataforma -->
        <div class="mb-6">
            <BotonesNavegacion @cambio-plataforma="plataformaActual = $event" />
        </div>

        <header class="header-container">
            <h1>Alta de Geocercas</h1>
            <p class="description">Vista que permite registrar una geocerca en el sistema.</p>
        </header>

        <!-- Layout dos columnas: pasos + carrusel -->
        <div class="two-col">
            <div class="col-steps">
                <p class="steps-label">Herramientas de trazado</p>

                <div class="step-card">
                    <div class="step-badge">1</div>
                    <div>
                        <div class="step-title">Dibujar un círculo</div>
                        <div class="step-desc">Haga clic sobre el botón, luego clic en el mapa y arrastre
                        para definir el diámetro deseado.</div>
                    </div>
                </div>

                <div class="step-card">
                    <div class="step-badge">2</div>
                    <div>
                        <div class="step-title">Dibujar un polígono</div>
                        <div class="step-desc">Haga clic por cada vértice sobre el mapa. Para cerrar,
                        haga clic sobre el primer vértice.</div>
                    </div>
                </div>

                <div class="step-card">
                    <div class="step-badge">3</div>
                    <div>
                        <div class="step-title">Editar geocerca</div>
                        <div class="step-desc">Haga clic en el icono de edición y luego sobre la geocerca. Confirme
                        con <strong>Guardar</strong> o <strong>Cancelar</strong> para no editar.</div>
                    </div>
                </div>

                <div class="step-card">
                    <div class="step-badge">4</div>
                    <div>
                        <div class="step-title">Eliminar geocerca</div>
                        <div class="step-desc">Haga clic en el icono de basurero y luego sobre la geocerca. Confirme
                        con <strong>Guardar</strong> o use <strong>Borrar todo</strong> para limpiar sin
                        seleccionar.</div>
                    </div>
                </div>

                <div class="step-card">
                    <div class="step-badge step-badge--multi">5 - 7</div>
                    <div>
                        <div class="step-title">Controles del mapa</div>
                        <div class="step-desc">Pantalla Completa. Permite ver el mapa a lo largo y ancho de la pantalla. <strong>Zoom In (+) y Zoom Out (−) para
                        navegar el mapa.</strong></div>
                    </div>
                </div>
            </div>

            <div class="col-image">
                <!-- 1. Carrusel Interfaz Principal -->
                <transition name="fade" mode="out-in">
                    <CarruselAciqui :key="plataformaActual" :items="imagenesAltaMostrar" />
                </transition>
            </div>
        </div>

        <!-- Tipos de geocerca -->
        <div class="section-title-bar mb-4">
            <h2>Tipos de trazado</h2>
        </div>

        <div class="carousel-box">
            <!-- 2. Carrusel Tipos de Trazado -->
            <transition name="fade" mode="out-in">
                <CarruselAciqui :key="plataformaActual" :items="imagenesTrazadoMostrar" />
            </transition>
        </div>

        <!-- Formulario -->
        <div class="section-title-bar mb-4">
            <h2>Campos del formulario</h2>
        </div>

        <ol start="8" class="main-list">
            <li><strong>Ver formulario:</strong> Permite desplegar el panel de datos para la geocerca.</li>
        </ol>

        <div class="carousel-box">
            <!-- 3. Carrusel Campos del Formulario -->
            <transition name="fade" mode="out-in">
                <CarruselAciqui :key="plataformaActual" :items="imagenesFormularioMostrar" />
            </transition>
        </div>

        <div class="form-grid">
            <div class="field-row">
                <span class="field-key">A</span>
                <div><div class="field-label">Nombre</div><div class="field-desc">Identificador único de la geocerca</div></div>
            </div>
            <div class="field-row">
                <span class="field-key">G</span>
                <div><div class="field-label">Alerta</div><div class="field-desc">Entrada, Salida o Ambos</div></div>
            </div>
            <div class="field-row">
                <span class="field-key">B</span>
                <div><div class="field-label">Radio</div><div class="field-desc">Solo geocerca circular</div></div>
            </div>
            <div class="field-row">
                <span class="field-key">H</span>
                <div><div class="field-label">Asignar dispositivo</div><div class="field-desc">Activos vinculados</div></div>
            </div>
            <div class="field-row">
                <span class="field-key">C</span>
                <div><div class="field-label">Medida</div><div class="field-desc">Metros / Kilómetros</div></div>
            </div>
            <div class="field-row">
                <span class="field-key">I</span>
                <div><div class="field-label">Guardar y continuar</div><div class="field-desc">Almacena y permite crear otra</div></div>
            </div>
            <div class="field-row">
                <span class="field-key">D</span>
                <div><div class="field-label">Latitud</div><div class="field-desc">Coordenada decimal (editable)</div></div>
            </div>
            <div class="field-row">
                <span class="field-key">J</span>
                <div><div class="field-label">Cancelar</div><div class="field-desc">Revierte y sale al listado</div></div>
            </div>
            <div class="field-row">
                <span class="field-key">E</span>
                <div><div class="field-label">Longitud</div><div class="field-desc">Coordenada decimal (editable)</div></div>
            </div>
            <div class="field-row">
                <span class="field-key">K</span>
                <div><div class="field-label">Guardar geocerca</div><div class="field-desc">Almacena y sale al listado</div></div>
            </div>
            <div class="field-row">
                <span class="field-key">F</span>
                <div><div class="field-label">Color</div><div class="field-desc">Tono visual en el mapa</div></div>
            </div>
        </div>

        <!-- Nota peligro -->
        <div class="doc-note note-danger">
            <svg class="note-icon" width="15" height="15" viewBox="0 0 16 16" fill="none">
                <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
                <path d="M8 5v3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                <circle cx="8" cy="10.5" r="0.75" fill="currentColor"/>
            </svg>
            <div class="note-body">
                <span class="note-label">Nota</span>
                <p>La geocerca <strong>poligonal</strong> no incluye los campos B, C, D y E
                (radio, medida, latitud y longitud).</p>
            </div>
        </div>

        <!-- Notificación de Éxito -->
        <footer class="success-section">
            <p>Al guardar los cambios exitosamente, se mostrará la siguiente notificación:</p>
            
            <div class="carousel-box success-carousel">
                <transition name="fade" mode="out-in">
                    <!-- Usamos el componente para asegurar el ajuste de tamaño -->
                    <CarruselAciqui 
                        :key="plataformaActual" 
                        :items="imagenesExitoMostrar" 
                    />
                </transition>
            </div>
        </footer>

    </section>
</template>

<script setup>
import { ref, computed } from 'vue';
import CarruselAciqui from '../Carruselimg.vue';
import BotonesNavegacion from '../BotonesNavegacion.vue';

const plataformaActual = ref('web');

// --- DATOS AGRUPADOS (Evita errores de nombres duplicados) ---
const webData = {
    alta: [{ nombre: "Interfaz Principal", url: "/img/adminGeocercas/Alta_Principal.png", descripcion: "Referencia principal para el registro de geocercas." }],
    trazado: [
        { nombre: "Geocerca Circular", url: "/img/adminGeocercas/Geocerca_Circular.png", descripcion: "Trazado circular." },
        { nombre: "Geocerca Poligonal", url: "/img/adminGeocercas/Geocerca_Poligonal.png", descripcion: "Trazado poligonal." }
    ],
    formulario: [{ nombre: "Formulario de Registro", url: "/img/adminGeocercas/Formulario_Registro.png", descripcion: "Detalle de campos y configuración del formulario." }],
    exito: [{ nombre: "Notificación de éxito", url: "/img/adminGeocercas/Notificacion_Exito.png", descripcion: "Confirmación visual de cambios guardados." }]
};

const mobileData = {
    alta: [{ nombre: "Interfaz Principal", url: "/img/adminGeocercas/AgregarGeocerca_Principal_Movil.png", descripcion: "Referencia principal en móvil." }],
    trazado: [
        { nombre: "Geocerca Circular", url: "/img/adminGeocercas/Geocerca_Circular_Movil.png", descripcion: "Trazado circular móvil." },
        { nombre: "Geocerca Poligonal", url: "/img/adminGeocercas/Geocerca_Poligonal_Movil.png", descripcion: "Trazado poligonal móvil." }
    ],
    formulario: [{ nombre: "Formulario de Registro", url: "/img/adminGeocercas/Formulario_Movil.jpg", descripcion: "Formulario adaptado a móvil." }],
    exito: [{ nombre: "Notificación de éxito", url: "/img/adminGeocercas/Notificacion_Exito.png", descripcion: "Confirmación visual de cambios guardados." }]
};

// --- COMPUTED LOGIC (Ahora sí apuntan a los objetos correctos) ---
const imagenesAltaMostrar = computed(() => plataformaActual.value === 'web' ? webData.alta : mobileData.alta);
const imagenesTrazadoMostrar = computed(() => plataformaActual.value === 'web' ? webData.trazado : mobileData.trazado);
const imagenesFormularioMostrar = computed(() => plataformaActual.value === 'web' ? webData.formulario : mobileData.formulario);
const imagenesExitoMostrar = computed(() => plataformaActual.value === 'web' ? webData.exito : mobileData.exito);

</script>

<style scoped>
/* Espaciado para el selector de botones */
.mb-6 { margin-bottom: 2rem; }

/* Animación de transición */
.fade-enter-active, .fade-leave-active { transition: opacity 0.3s ease; }
.fade-enter-from, .fade-leave-to { opacity: 0; }

.section-title-bar {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px; /* Espacio debajo del título */
}

/* Este le da el color azul y el grosor */
.section-title-bar h2 {
    font-size: 20px;
    font-weight: 700;
    color: var(--primary-color); /* Aquí es donde toma el azul */
    margin: 0;
}
/* ── Descripción ──────────────────────────────────── */
.description {
    font-size: 15px;
    opacity: 0.8;
    margin-bottom: 24px;
}

/* ── Layout dos columnas ──────────────────────────── */
.two-col {
    display: flex;
    gap: 24px;
    align-items: flex-start;
    margin-bottom: 28px;
}

.col-steps { flex: 1; }
.col-image { 
    flex: 1.6; /* Mayor tamaño para la imagen principal */
    position: sticky; 
    top: 20px; 
}
/* ── Pasos ────────────────────────────────────────── */
.steps-label {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.07em;
    text-transform: uppercase;
    color: var(--primary-color);
    margin-bottom: 12px;
}

.step-card {
    display: flex;
    gap: 14px;
    align-items: flex-start;
    background: var(--code-bg);
    border: 1px solid var(--border-color);
    border-radius: 10px;
    padding: 14px 16px;
    margin-bottom: 10px;
    transition: border-color 0.2s ease;
    cursor: default;
}

.step-card:hover {
    border-color: var(--primary-color);
}

.step-badge {
    min-width: 28px;
    height: 28px;
    border-radius: 50%;
    background: var(--primary-color);
    color: #ffffff;
    font-size: 13px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.step-badge--multi {
    font-size: 11px;
}

.step-title {
    font-size: 14px;
    font-weight: 600;
    color: var(--text-color);
    margin-bottom: 4px;
}

.step-desc {
    font-size: 13px;
    color: var(--text-color);
    opacity: 0.8;
    line-height: 1.55;
}

/* ── Separadores de sección ───────────────────────── */
.section-divider {
    display: flex;
    align-items: center;
    gap: 12px;
    margin: 28px 0 16px;
}

.section-divider h3 {
    font-size: 13px;
    font-weight: 700;
    color: var(--text-color);
    white-space: nowrap;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    opacity: 0.6;
    margin: 0;
}

.divider-line {
    flex: 1;
    height: 1px;
    background: var(--border-color);
}

/* ── Tipos de geocerca ────────────────────────────── */
.methods-grid {
    display: flex;
    gap: 12px;
    margin-bottom: 16px;
}

.method-card {
    flex: 1;
    background: var(--code-bg);
    border: 1px solid var(--border-color);
    border-radius: 10px;
    padding: 16px;
    transition: border-color 0.2s ease;
}

.method-card:hover {
    border-color: var(--primary-color);
}

.method-icon {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: var(--primary-color);
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
    font-size: 14px;
}

.method-card h4 {
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 5px;
    color: var(--text-color);
}

.method-card p {
    font-size: 13px;
    color: var(--text-color);
    opacity: 0.75;
    line-height: 1.5;
    margin: 0;
}

/* ── Lista principal ──────────────────────────────── */
.main-list {
    padding-left: 20px;
    margin: 0 0 16px;
}

.main-list li {
    font-size: 14px;
    line-height: 1.6;
    margin-bottom: 8px;
}

/* ── Carrusel ─────────────────────────────────────── */
.carousel-box :deep(img) {
    width: 100%;
    height: auto;
    display: block;
}

/* Busca .success-carousel y aumenta el max-width */
.success-carousel {
    max-width: 700px; /* Antes era 400px */
    margin: 12px auto 0;
}

/* ── Grid de campos ───────────────────────────────── */
.form-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    margin: 16px 0;
}

.field-row {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    background: var(--code-bg);
    border: 1px solid var(--border-color);
    border-radius: 8px;
    padding: 10px 12px;
    font-size: 13px;
    transition: border-color 0.2s ease;
}

.field-row:hover {
    border-color: var(--primary-color);
}

.field-key {
    min-width: 20px;
    font-weight: 700;
    color: var(--primary-color);
    flex-shrink: 0;
    font-size: 14px;
}

.field-label {
    font-weight: 600;
    color: var(--text-color);
    font-size: 13px;
}

.field-desc {
    color: var(--text-color);
    opacity: 0.65;
    font-size: 12px;
    margin-top: 2px;
}

/* ── Sistema de Notas ─────────────────────────────── */
.doc-note {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-top: 8px;
    padding: 13px 16px;
    border-radius: 8px;
    border: 1px solid;
    font-size: 14px;
}

.note-icon {
    flex-shrink: 0;
    margin-top: 1px;
}

.note-body {
    display: flex;
    flex-direction: column;
    gap: 3px;
}

.note-label {
    font-size: 10.5px;
    font-weight: 700;
    letter-spacing: 0.09em;
    text-transform: uppercase;
}

.note-body p {
    margin: 0;
    line-height: 1.6;
}

.note-info    { background: var(--code-bg); border-color: var(--primary-color); color: var(--primary-color); }
.note-info p  { color: var(--text-color); }

.note-tip     { background: #f0fdf4; border-color: #16a34a; color: #16a34a; }
.note-tip p   { color: #14532d; }

.note-warning { background: #fffbeb; border-color: #d97706; color: #d97706; }
.note-warning p { color: #78350f; }

.note-danger  { background: #fff1f2; border-color: #dc2626; color: #dc2626; }
.note-danger p { color: #7f1d1d; }

/* ── Éxito Estilo Modificar ────────────────────────── */
.success-section {
    margin-top: 40px;
    padding-top: 20px;
    border-top: 1px solid var(--border-color);
    text-align: center;
}

.success-section p {
    font-size: 14px;
    opacity: 0.75;
    margin-bottom: 12px;
}

/* La imagen se adapta al contenedor */
.img-fluid-rounded {
    width: 100%;
    height: auto;
    border-radius: 6px;
    display: block;
}

/* ── Responsive ───────────────────────────────────── */
@media (max-width: 768px) {
    .two-col        { flex-direction: column; }
    .methods-grid   { flex-direction: column; }
    .form-grid      { grid-template-columns: 1fr; }
}
</style>